export default function isValidLink(link: string): boolean {
  const regex =
    /^https?:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]*$/
  return regex.test(link)
}
